import React from 'react';
import { connect } from 'react-redux';
import map from 'lodash/map';
import moment from 'moment';
import swal from 'sweetalert2';

import Loader from "../../../../../components/Loader";
import classNames from "classnames";
import { getLeagueStatusName } from "../../../../../helpers/league";
import SingleDatePickerWrapper from "../../../../../components/DatePicker/SingleDatePickerWrapper";

import earthFlag from '../../../../../assets/img/other/flag-earth.svg';
import { fetchStatsMasterLeaguesByStatus } from "../../../../../actions/entities/statistics/masterLeague";

class MasterLeaguesByStatus extends React.Component {
    constructor(props) {
        super(props);

        // We set the date to yesterday and we subtract 30 days
        const today = new Date();
        const end = moment(today.setDate(today.getDate())).format('YYYY-MM-DD');

        this.state = { end, lang: 'ALL' }
    }

    fetchStatsMasterLeaguesByStatus() {
        const { end } = this.state;
        const { isFetching } = this.props;

        if (!isFetching) {
            this.props.dispatch(fetchStatsMasterLeaguesByStatus({
                endDate: end,
            }, null, (type, error) => swal({
                title: `Oops...`,
                type: 'error',
                html: `Something went wrong:<br/>"${type}"<br/>${error}<br/>` +
                    `<pre><code>${JSON.stringify(error, undefined, 4)}</code></pre>`,
            })));
        }
    }

    toggleLang(value) {
        const { lang } = this.state;

        if (lang === value) { this.setState({ lang: 'ALL' }) }
        else { this.setState({ lang: value }) }
    }

    renderTable(current, previous) {
        if (!current) return false;
        return (
            <div className="mt-3 table-responsive">
                <table className="table table-striped">
                    <thead>
                    <tr className="bg-gray">
                        <th>Ligue</th>
                        <th className="text-center">Nombre</th>
                        <th className="text-center">vs S-1</th>
                    </tr>
                    </thead>
                    <tbody>
                    {map(current, (v, k) => (
                        <tr>
                            <td>{getLeagueStatusName(k)}</td>
                            <td className="text-center">{v}</td>
                            <td className="text-center">{previous[k]}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        );
    }

    renderMasterLeaguesByModeByStatus() {
        const { data, isFetching } = this.props;
        const { lang } = this.state;
        const table = data && data[lang];

        return (!isFetching && table) &&
                <div className="mb-4">
                    {this.renderTable(table.current, table.previous)}
                </div>
    }

    render() {
        const { end, lang } = this.state;
        const { isFetching } = this.props;

        return (
            <div id="leagues-stats-widget">
                <div className="box">
                    <div className="box-header with-border">
                        <h3 className="box-title pull-left">
                            <i className="fa fa-tags"/> master league par status
                        </h3><br />
                        Dernier status des master leagues le {this.state.end}, par mode, par nombre de joueur
                    </div>
                    <div className="box-body">
                        <div className="text-center">
                            <div className="inline lang">
                                <button
                                    className={classNames('btn btn-box-tool', { selected: lang === 'FR'})}
                                    onClick={() => this.toggleLang('FR')}
                                >
                                    <span className="flag-icon flag-icon-fr"/>
                                </button>
                                <button
                                    className={classNames('btn btn-box-tool', { selected: lang === 'GB' })}
                                    onClick={() => this.toggleLang('GB')}
                                >
                                    <span className="flag-icon flag-icon-gb"/>
                                </button>
                                <button
                                    className={classNames('btn btn-box-tool', { selected: lang === 'ES' })}
                                    onClick={() => this.toggleLang('ES')}
                                >
                                    <span className="flag-icon flag-icon-es"/>
                                </button>
                                <button
                                    className={classNames('btn btn-box-tool', { selected: lang === 'OTHER' })}
                                    onClick={() => this.toggleLang('OTHER')}
                                >
                                    <img src={earthFlag} alt="Drapeau de la terre" className="flag-img-btn" />
                                </button>
                            </div>
                            <div className="inline data-range-picker">
                                <SingleDatePickerWrapper
                                    initialDate={moment(end)}
                                    onDateChange={(date) => {
                                        this.setState({
                                            end: moment(date).format('YYYY-MM-DD')
                                        });
                                    }}
                                    isOutsideRange={() => false}
                                />
                                <button
                                    className="ml-2 inline btn btn-default"
                                    onClick={() => this.fetchStatsMasterLeaguesByStatus()}
                                >
                                    <i className="fa fa-refresh"/>
                                </button>
                            </div>
                        </div>
                    </div>
                    {isFetching && <Loader/>}
                    {this.renderMasterLeaguesByModeByStatus()}
                </div>
            </div>
        )
    }
}

export default connect(
    state => state.app.statistics.masterLeague.masterLeagueByStatus,
    dispatch => ({ dispatch })
)(MasterLeaguesByStatus);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/MasterLeague/MasterLeagueByStatus/index.js